
import AssociatedProducts from '@/components/AssociatedProducts.vue'
import commercialOperationPrice from '@/mixins/commercialOperationPrice'

const COUNT_TOKEN = '{count}'

export default {
  name: 'ModalProductAddedToCart',

  components: {
    AssociatedProducts,
  },

  mixins: [commercialOperationPrice],

  data() {
    return {
      recommended_products_list: [],
    }
  },

  computed: {
    operationPrice() {
      return this.operationPriceOf(this.$store.state.product_added_to_cart, {
        beforeTax: false,
      })
    },
    addedVariant() {
      return this.$store.state.product_added_to_cart.variant
    },
    addedPrice() {
      const variant = this.addedVariant
      if (!variant) return null
      const price = variant.user_price_ttc ?? variant.price_ttc
      return typeof price === 'number' ? price : null
    },
    freeShippingOffer() {
      return this.$store.getters.free_shipping_offer
    },
    freeShipping() {
      return this.freeShippingOffer?.amount ?? null
    },
    freeShippingRelay() {
      return !!this.freeShippingOffer?.relay
    },
    cartTotal() {
      const total = this.$store.state.cart?.total_ttc
      return typeof total === 'number' ? total : null
    },
    showFreeShippingProgress() {
      return (
        this.freeShipping &&
        this.cartTotal !== null &&
        this.cartTotal < this.freeShipping
      )
    },
    freeShippingReached() {
      return (
        this.freeShipping &&
        this.cartTotal !== null &&
        this.cartTotal >= this.freeShipping
      )
    },
    freeShippingRemaining() {
      return Math.max(0, this.freeShipping - this.cartTotal)
    },
    freeShippingPercent() {
      if (!this.freeShipping) return 0
      return Math.min(100, (this.cartTotal / this.freeShipping) * 100)
    },
    cartItemsQuantity() {
      return (
        this.$store.state.cart?.order_variants?.reduce(
          (acc, obj) => acc + obj.quantity,
          0
        ) || 0
      )
    },
    cartItemsSegments() {
      const text = this.$tc(
        'components.modalProductAddedToCart.cartItemsCount',
        this.cartItemsQuantity,
        { count: COUNT_TOKEN }
      )
      const index = text.indexOf(COUNT_TOKEN)
      if (index < 0) return [{ key: 'text', text }]

      return [
        { key: 'before', text: text.slice(0, index) },
        { key: 'count', isCount: true },
        { key: 'after', text: text.slice(index + COUNT_TOKEN.length) },
      ].filter(segment => segment.isCount || segment.text)
    },
  },

  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId == 'modalProductAddedToCart') {
        this.$productService
          .fetchProductModalAddToCartSuggestions(
            this.$store.state.product_added_to_cart.id,
            { limit: 4 }
          )
          .then(({ data }) => {
            this.recommended_products_list = data
          })
          .catch(() => {
            this.recommended_products_list = []
          })
      }
    })
  },
}
